const en = {
  copyRight: '蜀ICP备2022026212号-1',
  home: 'Home',
  examination: 'Examination',
  course: 'Course',
  record: 'Record',
  help: 'Help',
  register: 'Register',
  login: 'Login',
  usernamePasswordLogin: 'Username Login',
  search: 'Search',
  reset: 'Reset',
  username: 'Username',
  usernameOrEmail: 'Username or email',
  password: 'Password',
  oldPassword: 'Old Password',
  newPassword: 'New Password',
  confirm: 'Confirm',
  sure: 'Confirm',
  cancel: 'Cancel',
  save: 'Save',
  submit: 'Submit',
  confirmSubmit: 'Confirm submit?',
  tenantCode: 'TenantCode',
  email: 'Email',
  validationCode: 'Validation code',
  inputValidationCode: 'Input validation code',
  forgetPassword: 'Forget Password?',
  smsCodeLogin: 'Sms code login',
  phoneNumber: 'Phone Number',
  sendValidationCode: 'Send validation code',
  send: 'Send',
  cutdown: 'Reacquire in {count}s',
  sendSuccess: 'Send success',
  registerSuccess: 'Register success',
  success: 'Success',
  failed: 'Failed',
  operation: 'Operation',
  return: 'Return',
  load: {
    loadMore: 'Load more',
    loadFailed: 'Load Failed!',
    noMoreData: 'No more data!',
    loading: 'Loading'
  },
  validate: {
    inputUsername: 'Please input username',
    inputEmail: 'Please input email',
    inputPassword: 'Please input password',
    inputValidationCode: 'Please input validation code',
    inputPhoneNumber: 'Please input phone number',
    usernameExists: 'Username exists',
    inputPhoneLen: 'Please input eleven length phone number',
    passwordMustFourLength: 'Please input four length password at least',
    validationCodeMustFourLength: 'Please input four length validation code at least'
  },
  language: {
    zh: '中文',
    en: 'English'
  },
  common: {
    link: 'Link',
    tool: 'Tool',
    community: 'Community',
    gitee: 'Gitee',
    github: 'Github',
    admin: 'Admin',
    changeLog: 'Changelog',
    feedback: 'Feedback',
    legalNotices: 'Legal Notice',
    legalNoticesContent: 'This is only for personal practice open-source imitation project, for learning reference only, and cannot bear any legal issues',
    privacyPolicy: 'Privacy Policy',
    privacyPolicyContent: 'This website will not strictly comply with relevant laws and regulations and the content stated in this privacy policy to collect and use your information',
    developerCenter: 'Developer Center'
  },
  header: {
    sourceCode: 'Source Code',
    document: 'Document',
    changeLog: 'ChangeLog',
    roadmap: 'Roadmap',
    admin: 'Admin',
    personal: 'Personal',
    changePwd: 'Change Password',
    logout: 'Logout'
  },
  homePage: {
    startUsing: 'Start using',
    userCnt: 'User',
    examinationCnt: 'Examination',
    subjectCnt: 'Subject',
    courseCnt: 'Course',
    popularCourses: 'Popular courses',
    loadFailed: 'Load failed!',
    loadCoursesFailed: 'Load popular courses failed!'
  },
  exam: {
    examinationName: 'Examination name',
    examinationType: 'Type',
    examinationTime: 'Time',
    status: 'Status',
    score: 'Score',
    scoreDetail: 'Detail',
    scoreRank: 'Rank',
    course: {
      courseName: 'Course Name',
      courseIntroduction: 'Course Introduction',
      chapter: 'Chapter',
      courseEvaluation: 'Evaluation',
      inputEvaluation: 'Please enter the evaluation content',
      studyExchange: 'Study exchange',
      courseAttach: 'Attachment',
      registerStudents: 'Register students',
      registerStudents1: 'Registered students',
      courseFeatures: 'Course features',
      learnHour: 'Learn hour',
      chapter1: 'Chapter',
      memberCount: 'Student count',
      evaluatesCount: 'Evaluates count',
      youMayAlsoLike: 'Guess you like',
      hour: 'hour',
      charge: 'charge',
      free: 'free',
      registration: 'Registration',
      cancelRegistration: 'Cancel registration',
      pleaseRegistration: 'Please registration',
      startLearn: 'Learn',
      submitSuccess: 'Submit success',
      submitFailed: 'Submit failed',
      doNotResubmit: 'Do not resubmit',
      defaultEvaluate: 'User default positive reviews',
      demoCourseName: 'Writing',
      courses: {
        popularCourses: 'Popular courses',
        registerStudentsCnt: 'Register students Count',
        level: 'Difficulty level'
      }
    },
    records: {
      records: 'Records'
    },
    exams: {
      all: 'All',
      latestRelease: 'Latest release',
      mostClicks: 'Most clicks',
      parameters: 'Parameters',
      end: 'The exam has ended',
      notStarted: 'Exam not started',
      sureStart: 'Are you sure you want to start?',
      startFailed: 'Start failed'
    },
    startExam: {
      last: 'Previous',
      next: 'Next',
      progress: 'progress',
      answerCard: 'Answer Card',
      isFirst: 'It\'s already the first subject',
      isLast: 'It\'s already the last subject',
      getSubjectFailed: 'Failed to get subject',
      confirmExit: 'confirm exit?',
      startExam: 'Start exam',
      subject: 'Subject count',
      score: 'Total score'
    },
    incorrect: {
      userName: 'UserName',
      score: 'Total score',
      startTime: 'Start time',
      endTime: 'End time',
      duration: 'Duration',
      correctNumber: 'Correct count',
      inCorrectNumber: 'Incorrect count',
      subjectList: 'Subject list',
      userAnswer: 'Your answer',
      answer: 'Answer',
      analysis: 'Analysis',
      right: 'Right',
      wrong: 'Wrong',
      loadSubjectFailed: 'Failed to get subjects',
      operator: 'Reviewed: automatically rated by the system'
    }
  },
  personal: {
    account: {
      identifier: 'Account',
      name: 'Name',
      gender: 'Gender',
      born: 'Date of birth',
      phone: 'Phone',
      email: 'Email',
      avatar: 'Avatar',
      inputIdentifier: 'Please enter an account',
      modifySuccess: 'Successfully modified',
      modifyFailed: 'Modification failed',
      avatarUploadSuccess: 'Successfully uploaded the avatar',
      avatarUploadFailed: 'Failed to upload avatar',
      avatarUploadFormat: 'Uploading avatar images can only be in jpg/png format!',
      avatarUploadSize: 'The size of the uploaded avatar image cannot exceed 2MB!'
    },
    pwd: {
      oldPwd: 'Old password',
      newPwd: 'New password',
      confirmPwd: 'Confirm new password',
      inputNewPwd: 'Please enter a new password',
      inputOldPwd: 'Please enter your old password',
      pwdLenTips: 'Password cannot be less than 6 digits',
      inputPwdAgain: 'Please enter the password again',
      pwdNotEqual: 'The two passwords entered do not match!',
      modifySuccess: 'Successfully modified',
      modifyFailed: 'Modification failed'
    }
  },
  status: {
    examination: 'examination',
    practice: 'practice',
    questionnaire: 'questionnaire',
    interview: 'interview',
    complete: 'Statistics completed',
    markComplete: 'Corrected',
    todoMark: 'To be corrected',
    right: 'Right',
    wrong: 'Wrong',
    men: 'Men',
    women: 'Women'
  },
  media: {
    audio: {
      progress: 'Progress bar:',
      limit: 'Reached playback limit',
      playFailed: 'Failed to play voice',
      play: 'Play',
      pause: 'Pause',
      muted: 'Muted',
      notMuted: 'Play',
      transSpeed: 'Fast forward: x'
    },
    video: {
      playError: 'This video cannot be played at the moment. Please try again later'
    }
  },
  searchForm: {
    q: 'Please input keyword',
    course: 'Course',
    exam: 'Examination',
    other: 'Other',
    searchSuccess: 'Search success',
    searchFailed: 'Search failed'
  }
}

export default en



// WEBPACK FOOTER //
// ./src/locales/lang/en/en.js